import React, { useState } from 'react';
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../../store/authSlice';
import {
  FiGrid, FiPackage, FiShoppingBag, FiUsers, FiLogOut,
  FiMenu, FiX, FiBell, FiSettings, FiChevronRight, FiHome
} from 'react-icons/fi';
import './Admin.css';

const NAV = [
  { path: '/admin', label: 'Dashboard', icon: FiGrid, exact: true },
  { path: '/admin/products', label: 'Products', icon: FiPackage },
  { path: '/admin/orders', label: 'Orders', icon: FiShoppingBag },
  { path: '/admin/users', label: 'Users', icon: FiUsers },
  { path: '/admin/homepage', label: 'Homepage', icon: FiHome },
];

export default function AdminLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector(s => s.auth);
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleLogout = () => { dispatch(logout()); navigate('/login'); };

  const isActive = (path, exact) => exact ? location.pathname === path : location.pathname.startsWith(path);

  return (
    <div className="admin-layout">
      {/* Sidebar */}
      <aside className={`admin-sidebar${sidebarOpen ? '' : ' collapsed'}`}>
        <div className="admin-sidebar-header">
          <Link to="/" className="admin-logo">
            <span>HUGE</span>
            {sidebarOpen && <span className="admin-tag">ADMIN</span>}
          </Link>
          <button className="sidebar-toggle" onClick={() => setSidebarOpen(!sidebarOpen)}>
            {sidebarOpen ? <FiX /> : <FiMenu />}
          </button>
        </div>

        <nav className="admin-nav">
          {NAV.map(item => {
            const Icon = item.icon;
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`admin-nav-item${isActive(item.path, item.exact) ? ' active' : ''}`}
              >
                <Icon className="admin-nav-icon" />
                {sidebarOpen && <span>{item.label}</span>}
                {sidebarOpen && isActive(item.path, item.exact) && <FiChevronRight className="admin-nav-arrow" />}
              </Link>
            );
          })}
        </nav>

        <div className="admin-sidebar-footer">
          <Link to="/admin/settings" className="admin-nav-item">
            <FiSettings className="admin-nav-icon" />
            {sidebarOpen && <span>Settings</span>}
          </Link>
          <button className="admin-nav-item logout-btn" onClick={handleLogout}>
            <FiLogOut className="admin-nav-icon" />
            {sidebarOpen && <span>Logout</span>}
          </button>
        </div>
      </aside>

      {/* Main */}
      <div className="admin-main">
        {/* Top Bar */}
        <header className="admin-topbar">
          <h1 className="admin-page-title">
            {NAV.find(n => isActive(n.path, n.exact))?.label || location.pathname.split('/').pop()?.replace(/^./, c => c.toUpperCase()) || 'Admin'}
          </h1>
          <div className="admin-topbar-right">
            <button className="admin-topbar-btn">
              <FiBell />
              <span className="notif-badge">3</span>
            </button>
            <Link to="/" className="admin-topbar-btn" title="View Store">
              🛍️
            </Link>
            <div className="admin-user-chip">
              <div className="admin-user-avatar">{user?.name?.charAt(0) || 'A'}</div>
              <div>
                <p className="admin-user-name">{user?.name || 'Admin'}</p>
                <p className="admin-user-role">Administrator</p>
              </div>
            </div>
          </div>
        </header>

        {/* Page Content */}
        <main className="admin-content">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
